import React, { Fragment } from "react";
import { Table } from "react-bootstrap";


const InvoiceCard = (props) => {

    return (
        <Fragment>
            <div className='timeSheet-project-card mb-1 mt-3'>
                {/* <div>
                    <h4 className='timeSheet-project-title'>{props?.projectName}</h4>
                </div> */}
            </div>
            <Table className='cart-table table-bordered'>
                <thead>
                    <tr className='cart-table-header'>
                        <th colSpan={3}>
                            <h4 className='timeSheet-project-title'>{props?.projectName}</h4>
                        </th>

                        <th>
                            <strong>Sun</strong>
                        </th>
                        <th>
                            <strong>Mon</strong>
                        </th>
                        <th>
                            <strong>Tue</strong>
                        </th>
                        <th>
                            <strong>Wed</strong>
                        </th>
                        <th>
                            <strong>Thr</strong>
                        </th>
                        <th>
                            <strong>Fri</strong>
                        </th>

                        <th>
                            <strong>Sat</strong>
                        </th>
                        <th className='text-center'>
                            <strong>Total Hrs</strong>
                        </th>
                        <th className='text-center'>
                            <strong>Action</strong>
                        </th>
                    </tr>
                </thead>

                {
                    props?.details?.weeks_table?.map((element, zIndex) => {
                        return (
                            <>
                                <thead>
                                    <tr className='cart-table-header'>
                                        <th>
                                            <strong>Project</strong>
                                        </th>

                                        <th>
                                            <strong>Activity</strong>
                                        </th>
                                        <th>
                                            <strong>Task</strong>
                                        </th>
                                        {
                                            element?.time_table?.length > 0 &&
                                            element.time_table.slice(0, 7).map((dates, dateIndex) => (
                                                <th key={dateIndex}>
                                                    <strong>{dates.date}</strong>
                                                </th>
                                            ))
                                        }
                                        <th className='text-center'>
                                            <strong></strong>
                                        </th>
                                        <th className='text-center'>
                                            {/* <strong>Action</strong> */}
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        element?.data_table?.length > 0 ? (element?.data_table?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{item.project_id}</td>
                                                    <td>{item.activity_id}</td>
                                                    <td>{item.task_id}</td>

                                                    {item.time_details?.slice(0, 7).map((times, timesIndex, arr) => (
                                                        <td
                                                            key={timesIndex}
                                                            className={`${times?.holiday ? "disable-column" : ""}`}
                                                        >
                                                            {timesIndex === 0 || timesIndex === arr.length - 1 ? (
                                                                '' // empty for first and last
                                                            ) : !props.isConfig && times.working_hour > 0 ? (
                                                                <button
                                                                    className="time-link"
                                                                    onClick={() => props.getTimeDetails(timesIndex, item.task_id)}
                                                                >
                                                                    {times.working_hour}
                                                                </button>
                                                            ) : (
                                                                times?.holiday ? '0' : times?.working_hour
                                                            )}
                                                        </td>
                                                    ))}

                                                    <td className='total-hrs'>{item.total_hour}</td>
                                                    <td className='total-hrs'>
                                                        {props.note == false ? null :
                                                            <button
                                                                onClick={() => props.onNoteHandler(item.id)}
                                                                className="new-node-btn"><i class="bi bi-pencil-square"></i></button>
                                                        }
                                                    </td>

                                                </tr>
                                            );
                                        })
                                        ) : (<tr className="table-row-nodata">
                                            <td colSpan={12} className="text-center">No data available</td>
                                        </tr>
                                        )}
                                </tbody>

                            </>);
                    })
                }

                <tbody>
                    <tr className='total-time'>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td colSpan={2}><strong>TOTAL HOURS :</strong></td>
                        <td className='total-hrs'><strong>{props?.details?.total_hour}</strong></td>
                        <td className='total-hrs'></td>
                    </tr>
                    {props.type !== 1 ?
                        <tr className='total-time'>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td colSpan={2}><strong>RATE PER HOURS :</strong></td>
                            <td className='total-hrs'><strong>${props?.details?.emp_rate ? props?.details.emp_rate : 0}</strong></td>
                            <td className='total-hrs'></td>
                        </tr>
                        : null}
                    <tr className='total-time'>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td colSpan={2}><strong>TOTAL PAY :</strong></td>
                        <td className='total-hrs'><strong>${Math.floor(props?.details?.total_pay)}</strong></td>
                        <td className='total-hrs'></td>
                    </tr>
                    {/* <tr className='total-time'>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td colSpan={2}><strong>TOTAL LEAVE :</strong></td>
                        <td className='total-hrs'><strong>{props.details?.total_leave}</strong></td>
                         <td className='total-hrs'></td>
                    </tr> */}
                </tbody>
            </Table>
        </Fragment>
    )
}

export default InvoiceCard;